import { EkycStatus, UserAttrType, setUserBitmap, qryUserProfile } from '@tencent/wphk-act-base-cgi';

import { cacheFunc } from '@tencent/wphk-base-utils';

/**
 * 是否有绑卡或ekyc完成
 */
export const hasBindCardOrEkyc = cacheFunc(async () => {
  const { ekyc, isBindCard } = await setUserBitmap({ userAttrList: [UserAttrType.ekyc, UserAttrType.bindCard] });
  return ekyc !== EkycStatus.pass && !isBindCard;
});


/**
 * 查询用户是否为港人内地新回用户
 */
export const isReturningHKUser = cacheFunc(async () => {
  const { attrFlag } = await qryUserProfile({ attrName: 'grndnew' as any });
  return attrFlag;
});
